import { render, staticRenderFns } from "./TheLogo.vue?vue&type=template&id=1d2aa1f3&scoped=true&"
import script from "./TheLogo.vue?vue&type=script&lang=ts&"
export * from "./TheLogo.vue?vue&type=script&lang=ts&"
import style0 from "./TheLogo.vue?vue&type=style&index=0&id=1d2aa1f3&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2aa1f3",
  null
  
)

export default component.exports